var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-settings-page-wrap"},[_c('b-row',{attrs:{"no-gutters":""}},[_c('BrandSettingsSidebar'),_c('b-col',{attrs:{"md":"10"}},[_c('div',{staticClass:"p-4"},[_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }